import router from '~/router';
import { signOut } from '~/api/user';

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = {
  data: null,
};

const mutations = {
  SET_USER: (state, user) => {
    state.data = user;
  },
  DEL_USER: (state) => {
    state.data = null;
  },
};

const actions = {
  signIn({ commit }, user) {
    commit('SET_USER', user);
  },

  async signOut({ commit }) {
    commit('DEL_USER');
    await signOut();
    router.push('/login');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
